import axios from 'axios';

// Action types
export const FETCH_SPECS_LIST_STARTED = 'backend-specs/fetch-specs-list-started';
export const FETCH_SPECS_LIST_SUCCESS = 'backend-specs/fetch-specs-list-success';
export const FETCH_SPECS_LIST_FAILURE = 'backend-specs/fetch-specs-list-failure';

export const FETCH_SPEC_DETAILS_STARTED = 'backend-specs/fetch-spec-details-started';
export const FETCH_SPEC_DETAILS_SUCCESS = 'backend-specs/fetch-spec-details-success';
export const FETCH_SPEC_DETAILS_FAILURE = 'backend-specs/fetch-spec-details-failure';

export const SAVE_SPEC_STARTED = 'backend-specs/save-spec-started';
export const SAVE_SPEC_SUCCESS = 'backend-specs/save-spec-success';
export const SAVE_SPEC_FAILURE = 'backend-specs/save-spec-failure';

export const SET_CURRENT_SPEC = 'backend-specs/set-current-spec';
export const CLEAR_CURRENT_SPEC = 'backend-specs/clear-current-spec';

export const FETCH_HEALTH_STARTED = 'backend-specs/fetch-health-started';
export const FETCH_HEALTH_SUCCESS = 'backend-specs/fetch-health-success';
export const FETCH_HEALTH_FAILURE = 'backend-specs/fetch-health-failure';

export const DELETE_SPEC_STARTED = 'backend-specs/delete-spec-started';
export const DELETE_SPEC_SUCCESS = 'backend-specs/delete-spec-success';
export const DELETE_SPEC_FAILURE = 'backend-specs/delete-spec-failure';

export const SAVE_ENDPOINT_SETTING_STARTED = 'backend-specs/save-endpoint-setting-started';
export const SAVE_ENDPOINT_SETTING_SUCCESS = 'backend-specs/save-endpoint-setting-success';
export const SAVE_ENDPOINT_SETTING_FAILURE = 'backend-specs/save-endpoint-setting-failure';

export const UPDATE_UPSTREAM_STARTED = 'backend-specs/update-upstream-started';
export const UPDATE_UPSTREAM_SUCCESS = 'backend-specs/update-upstream-success';
export const UPDATE_UPSTREAM_FAILURE = 'backend-specs/update-upstream-failure';

export const FETCH_GLOBAL_CONFIG_STARTED = 'backend-specs/fetch-global-config-started';
export const FETCH_GLOBAL_CONFIG_SUCCESS = 'backend-specs/fetch-global-config-success';
export const FETCH_GLOBAL_CONFIG_FAILURE = 'backend-specs/fetch-global-config-failure';

export const UPDATE_GLOBAL_CONFIG_STARTED = 'backend-specs/update-global-config-started';
export const UPDATE_GLOBAL_CONFIG_SUCCESS = 'backend-specs/update-global-config-success';
export const UPDATE_GLOBAL_CONFIG_FAILURE = 'backend-specs/update-global-config-failure';

// Action creators
export const fetchSpecsListStarted = () => ({
  type: FETCH_SPECS_LIST_STARTED,
});

export const fetchSpecsListSuccess = (specs) => ({
  type: FETCH_SPECS_LIST_SUCCESS,
  payload: specs,
});

export const fetchSpecsListFailure = (error) => ({
  type: FETCH_SPECS_LIST_FAILURE,
  payload: error,
  error: true,
});

export const fetchSpecDetailsStarted = () => ({
  type: FETCH_SPEC_DETAILS_STARTED,
});

export const fetchSpecDetailsSuccess = (spec) => ({
  type: FETCH_SPEC_DETAILS_SUCCESS,
  payload: spec,
});

export const fetchSpecDetailsFailure = (error) => ({
  type: FETCH_SPEC_DETAILS_FAILURE,
  payload: error,
  error: true,
});

export const saveSpecStarted = () => ({
  type: SAVE_SPEC_STARTED,
});

export const saveSpecSuccess = (spec) => ({
  type: SAVE_SPEC_SUCCESS,
  payload: spec,
});

export const saveSpecFailure = (error) => ({
  type: SAVE_SPEC_FAILURE,
  payload: error,
  error: true,
});

export const setCurrentSpec = (spec) => ({
  type: SET_CURRENT_SPEC,
  payload: spec,
});

export const clearCurrentSpec = () => ({
  type: CLEAR_CURRENT_SPEC,
});

export const fetchHealthStarted = () => ({
  type: FETCH_HEALTH_STARTED,
});

export const fetchHealthSuccess = (health) => ({
  type: FETCH_HEALTH_SUCCESS,
  payload: health,
});

export const fetchHealthFailure = (error) => ({
  type: FETCH_HEALTH_FAILURE,
  payload: error,
  error: true,
});

export const deleteSpecStarted = () => ({
  type: DELETE_SPEC_STARTED,
});

export const deleteSpecSuccess = (specId) => ({
  type: DELETE_SPEC_SUCCESS,
  payload: specId,
});

export const deleteSpecFailure = (error) => ({
  type: DELETE_SPEC_FAILURE,
  payload: error,
  error: true,
});

export const saveEndpointSettingStarted = () => ({
  type: SAVE_ENDPOINT_SETTING_STARTED,
});

export const saveEndpointSettingSuccess = (endpointSetting) => ({
  type: SAVE_ENDPOINT_SETTING_SUCCESS,
  payload: endpointSetting,
});

export const saveEndpointSettingFailure = (error) => ({
  type: SAVE_ENDPOINT_SETTING_FAILURE,
  payload: error,
  error: true,
});

export const updateUpstreamStarted = () => ({
  type: UPDATE_UPSTREAM_STARTED,
});

export const updateUpstreamSuccess = (spec) => ({
  type: UPDATE_UPSTREAM_SUCCESS,
  payload: spec,
});

export const updateUpstreamFailure = (error) => ({
  type: UPDATE_UPSTREAM_FAILURE,
  payload: error,
  error: true,
});

// Thunk actions
export const fetchSpecsList = () => async (system) => {
  const { backendSpecsActions, backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  backendSpecsActions.fetchSpecsListStarted();

  try {
    const response = await axios.get(`${baseUrl}/specs`);
    backendSpecsActions.fetchSpecsListSuccess(response.data);
    return { payload: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch specs';
    backendSpecsActions.fetchSpecsListFailure(errorMessage);
    return { error: true, meta: { errorMessage } };
  }
};

export const fetchSpecDetails = (specId) => async (system) => {
  const { backendSpecsActions, backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  backendSpecsActions.fetchSpecDetailsStarted();

  try {
    const response = await axios.get(`${baseUrl}/specs/${specId}`);
    backendSpecsActions.fetchSpecDetailsSuccess(response.data);
    return { payload: response.data };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || 'Failed to fetch spec details';
    backendSpecsActions.fetchSpecDetailsFailure(errorMessage);
    return { error: true, meta: { errorMessage } };
  }
};

export const loadSpecIntoEditor = (specId) => async (system) => {
  const { backendSpecsActions, editorActions, EditorContentOrigin } = system;

  const result = await backendSpecsActions.fetchSpecDetails(specId);

  if (result.error) {
    return result;
  }

  // Backend returns { spec: {...metadata}, content: '...', endpointSettings: [...] }
  const response = result.payload;
  const specMetadata = response.spec || {};
  const content = response.content || response.yaml || response.json || '';

  if (content) {
    editorActions.setContent(content, EditorContentOrigin.BackendLoad);
  }

  // Track the loaded spec as current - use the nested spec metadata
  backendSpecsActions.setCurrentSpec({
    id: specMetadata.id,
    name: specMetadata.name || specMetadata.title,
    version: specMetadata.version,
  });

  // Update URL to reflect loaded spec
  backendSpecsActions.updateUrlWithSpecName(specMetadata.name);

  return result;
};

export const loadSpecByName = (specName) => async (system) => {
  const { backendSpecsActions, backendSpecsSelectors, editorActions, EditorContentOrigin } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  console.log('[loadSpecByName] Loading spec by name:', specName);
  backendSpecsActions.fetchSpecDetailsStarted();

  try {
    const response = await axios.get(`${baseUrl}/specs/by-name/${encodeURIComponent(specName)}`);
    console.log('[loadSpecByName] Response:', response.data);
    backendSpecsActions.fetchSpecDetailsSuccess(response.data);

    // Backend returns { spec: {...metadata}, content: '...', endpointSettings: [...] }
    const specMetadata = response.data.spec || {};
    const content = response.data.content || response.data.yaml || response.data.json || '';

    console.log('[loadSpecByName] Spec metadata:', specMetadata);
    console.log('[loadSpecByName] Spec ID:', specMetadata.id, 'Name:', specMetadata.name);

    if (content) {
      editorActions.setContent(content, EditorContentOrigin.BackendLoad);
    }

    // Track the loaded spec as current
    const currentSpecData = {
      id: specMetadata.id,
      name: specMetadata.name || specMetadata.title,
      version: specMetadata.version,
    };
    console.log('[loadSpecByName] Setting currentSpec:', currentSpecData);
    backendSpecsActions.setCurrentSpec(currentSpecData);

    return { payload: response.data };
  } catch (error) {
    console.error('[loadSpecByName] Error:', error);
    const errorMessage =
      error.response?.data?.message || error.message || 'Failed to load spec by name';
    backendSpecsActions.fetchSpecDetailsFailure(errorMessage);
    return { error: true, meta: { errorMessage } };
  }
};

export const updateUrlWithSpecName = (specName) => () => {
  if (specName) {
    const newUrl = `/${encodeURIComponent(specName)}`;
    if (window.location.pathname !== newUrl) {
      window.history.pushState({}, '', newUrl);
    }
  }
};

export const clearUrlSpec = () => () => {
  if (window.location.pathname !== '/') {
    window.history.pushState({}, '', '/');
  }
};

export const newSpec = () => (system) => {
  const {
    backendSpecsActions,
    editorActions,
    EditorContentOrigin,
    editorContentFixturesSelectors,
  } = system;

  // Clear current spec tracking
  backendSpecsActions.clearCurrentSpec();

  // Clear URL
  backendSpecsActions.clearUrlSpec();

  // Load empty or default template
  const defaultContent =
    editorContentFixturesSelectors?.selectOpenAPI310PetstoreYAML?.() ||
    `openapi: 3.1.0
info:
  title: New API
  version: 1.0.0
paths: {}
`;

  editorActions.setContent(defaultContent, EditorContentOrigin.Clear);
};

export const saveSpec =
  (name, specId = null) =>
  async (system) => {
    const { backendSpecsActions, backendSpecsSelectors, specSelectors } = system;
    const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();
    const content = specSelectors.specStr();

    // Use passed specId, or fall back to selector
    const currentSpec = backendSpecsSelectors.selectCurrentSpec();
    const idToUse = specId || currentSpec?.id;

    backendSpecsActions.saveSpecStarted();

    try {
      let response;
      if (idToUse) {
        // Update existing spec
        response = await axios.put(`${baseUrl}/specs/${idToUse}`, {
          name: name || currentSpec?.name,
          content,
        });
      } else {
        // Create new spec
        response = await axios.post(`${baseUrl}/specs`, {
          name,
          content,
        });
      }

      const savedSpec = response.data;
      backendSpecsActions.saveSpecSuccess(savedSpec);

      // Update current spec tracking
      backendSpecsActions.setCurrentSpec({
        id: savedSpec.id,
        name: savedSpec.name || savedSpec.title,
        version: savedSpec.version,
      });

      // Update URL with spec name
      backendSpecsActions.updateUrlWithSpecName(savedSpec.name);

      return { payload: savedSpec };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to save spec';
      backendSpecsActions.saveSpecFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }
  };

export const fetchHealthStatus = () => async (system) => {
  const { backendSpecsActions, backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  backendSpecsActions.fetchHealthStarted();

  try {
    // Fetch all three health endpoints in parallel
    const [healthRes, readyRes, liveRes] = await Promise.allSettled([
      axios.get(`${baseUrl}/health`),
      axios.get(`${baseUrl}/health/ready`),
      axios.get(`${baseUrl}/health/live`),
    ]);

    const health = {
      overall:
        healthRes.status === 'fulfilled'
          ? healthRes.value.data
          : { status: 'DOWN', error: healthRes.reason?.message },
      ready:
        readyRes.status === 'fulfilled'
          ? readyRes.value.data
          : { status: 'DOWN', error: readyRes.reason?.message },
      live:
        liveRes.status === 'fulfilled'
          ? liveRes.value.data
          : { status: 'DOWN', error: liveRes.reason?.message },
      timestamp: new Date().toISOString(),
    };

    backendSpecsActions.fetchHealthSuccess(health);
    return { payload: health };
  } catch (error) {
    const errorMessage = error.message || 'Failed to fetch health status';
    backendSpecsActions.fetchHealthFailure(errorMessage);
    return { error: true, meta: { errorMessage } };
  }
};

export const deleteSpec = (specId) => async (system) => {
  const { backendSpecsActions, backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  backendSpecsActions.deleteSpecStarted();

  try {
    await axios.delete(`${baseUrl}/specs/${specId}`);
    backendSpecsActions.deleteSpecSuccess(specId);

    // Refresh the specs list after deletion
    await backendSpecsActions.fetchSpecsList();

    return { payload: specId };
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete spec';
    backendSpecsActions.deleteSpecFailure(errorMessage);
    return { error: true, meta: { errorMessage } };
  }
};

export const saveEndpointSetting =
  (path, method, selectedExample, delayMs = null) =>
  async (system) => {
    const { backendSpecsActions, backendSpecsSelectors, pagoAuth2Selectors } = system;
    const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();
    const currentSpec = backendSpecsSelectors.selectCurrentSpec();

    if (!currentSpec || !currentSpec.id) {
      const errorMessage = 'No spec loaded. Please load a spec first.';
      backendSpecsActions.saveEndpointSettingFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }

    const specId = currentSpec.id;
    backendSpecsActions.saveEndpointSettingStarted();

    try {
      const requestBody = {
        path,
        method: method.toUpperCase(),
        selectedExample,
      };

      // Only include delayMs if it's not null
      if (delayMs !== null) {
        requestBody.delayMs = delayMs;
      }

      // VIEWER_ENV users save endpoint settings via the environment-scoped API
      const isViewerEnv = pagoAuth2Selectors?.selectIsViewerEnv?.() || false;
      const userEnvironment = pagoAuth2Selectors?.selectUserEnvironment?.() || null;

      let response;
      if (isViewerEnv && userEnvironment) {
        response = await axios.put(
          `${baseUrl}/environments/${userEnvironment.id}/specs/${specId}/endpoints`,
          requestBody
        );
      } else {
        response = await axios.put(`${baseUrl}/specs/${specId}/endpoints`, requestBody);
      }

      const endpointSetting = response.data;
      backendSpecsActions.saveEndpointSettingSuccess(endpointSetting);

      return { payload: endpointSetting };
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || 'Failed to save endpoint setting';
      backendSpecsActions.saveEndpointSettingFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }
  };

export const updateUpstreamEnvironment =
  (specId, upstreamEnvironment, proxyMode, basePath) => async (system) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;
    const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

    backendSpecsActions.updateUpstreamStarted();

    try {
      const body = {
        upstreamEnvironment: upstreamEnvironment || '',
        proxyMode: proxyMode || 'mock',
      };
      if (basePath !== undefined) {
        body.basePath = basePath || '';
      }
      const response = await axios.patch(`${baseUrl}/specs/${specId}/upstream`, body);
      const updatedSpec = response.data;
      backendSpecsActions.updateUpstreamSuccess(updatedSpec);

      // Refresh the specs list to show updated upstream
      await backendSpecsActions.fetchSpecsList();

      return { payload: updatedSpec };
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || 'Failed to update upstream';
      backendSpecsActions.updateUpstreamFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }
  };

// Environment action types
export const FETCH_ENVIRONMENTS_STARTED = 'backend-specs/fetch-environments-started';
export const FETCH_ENVIRONMENTS_SUCCESS = 'backend-specs/fetch-environments-success';
export const FETCH_ENVIRONMENTS_FAILURE = 'backend-specs/fetch-environments-failure';

export const CREATE_ENVIRONMENT_STARTED = 'backend-specs/create-environment-started';
export const CREATE_ENVIRONMENT_SUCCESS = 'backend-specs/create-environment-success';
export const CREATE_ENVIRONMENT_FAILURE = 'backend-specs/create-environment-failure';

export const DELETE_ENVIRONMENT_STARTED = 'backend-specs/delete-environment-started';
export const DELETE_ENVIRONMENT_SUCCESS = 'backend-specs/delete-environment-success';
export const DELETE_ENVIRONMENT_FAILURE = 'backend-specs/delete-environment-failure';

export const FETCH_ENVIRONMENT_DETAIL_STARTED = 'backend-specs/fetch-environment-detail-started';
export const FETCH_ENVIRONMENT_DETAIL_SUCCESS = 'backend-specs/fetch-environment-detail-success';
export const FETCH_ENVIRONMENT_DETAIL_FAILURE = 'backend-specs/fetch-environment-detail-failure';

export const SET_ACTIVE_ENVIRONMENT = 'backend-specs/set-active-environment';

export const UPSERT_ENV_SPEC_SETTING_STARTED = 'backend-specs/upsert-env-spec-setting-started';
export const UPSERT_ENV_SPEC_SETTING_SUCCESS = 'backend-specs/upsert-env-spec-setting-success';
export const UPSERT_ENV_SPEC_SETTING_FAILURE = 'backend-specs/upsert-env-spec-setting-failure';

export const UPSERT_ENV_ENDPOINT_SETTING_STARTED = 'backend-specs/upsert-env-endpoint-setting-started';
export const UPSERT_ENV_ENDPOINT_SETTING_SUCCESS = 'backend-specs/upsert-env-endpoint-setting-success';
export const UPSERT_ENV_ENDPOINT_SETTING_FAILURE = 'backend-specs/upsert-env-endpoint-setting-failure';

// Environment action creators
export const fetchEnvironmentsStarted = () => ({ type: FETCH_ENVIRONMENTS_STARTED });
export const fetchEnvironmentsSuccess = (environments) => ({ type: FETCH_ENVIRONMENTS_SUCCESS, payload: environments });
export const fetchEnvironmentsFailure = (error) => ({ type: FETCH_ENVIRONMENTS_FAILURE, payload: error, error: true });

export const createEnvironmentStarted = () => ({ type: CREATE_ENVIRONMENT_STARTED });
export const createEnvironmentSuccess = (environment) => ({ type: CREATE_ENVIRONMENT_SUCCESS, payload: environment });
export const createEnvironmentFailure = (error) => ({ type: CREATE_ENVIRONMENT_FAILURE, payload: error, error: true });

export const deleteEnvironmentStarted = () => ({ type: DELETE_ENVIRONMENT_STARTED });
export const deleteEnvironmentSuccess = (envId) => ({ type: DELETE_ENVIRONMENT_SUCCESS, payload: envId });
export const deleteEnvironmentFailure = (error) => ({ type: DELETE_ENVIRONMENT_FAILURE, payload: error, error: true });

export const fetchEnvironmentDetailStarted = () => ({ type: FETCH_ENVIRONMENT_DETAIL_STARTED });
export const fetchEnvironmentDetailSuccess = (detail) => ({ type: FETCH_ENVIRONMENT_DETAIL_SUCCESS, payload: detail });
export const fetchEnvironmentDetailFailure = (error) => ({ type: FETCH_ENVIRONMENT_DETAIL_FAILURE, payload: error, error: true });

export const setActiveEnvironment = (environment) => ({ type: SET_ACTIVE_ENVIRONMENT, payload: environment });

export const upsertEnvSpecSettingStarted = () => ({ type: UPSERT_ENV_SPEC_SETTING_STARTED });
export const upsertEnvSpecSettingSuccess = (setting) => ({ type: UPSERT_ENV_SPEC_SETTING_SUCCESS, payload: setting });
export const upsertEnvSpecSettingFailure = (error) => ({ type: UPSERT_ENV_SPEC_SETTING_FAILURE, payload: error, error: true });

export const upsertEnvEndpointSettingStarted = () => ({ type: UPSERT_ENV_ENDPOINT_SETTING_STARTED });
export const upsertEnvEndpointSettingSuccess = (setting) => ({ type: UPSERT_ENV_ENDPOINT_SETTING_SUCCESS, payload: setting });
export const upsertEnvEndpointSettingFailure = (error) => ({ type: UPSERT_ENV_ENDPOINT_SETTING_FAILURE, payload: error, error: true });

// Environment thunk actions
export const fetchEnvironments =
  () =>
  async (system) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;
    const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

    backendSpecsActions.fetchEnvironmentsStarted();

    try {
      const response = await axios.get(`${baseUrl}/environments`);
      backendSpecsActions.fetchEnvironmentsSuccess(response.data);
      return { payload: response.data };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch environments';
      backendSpecsActions.fetchEnvironmentsFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }
  };

export const createEnvironment =
  (name, description) =>
  async (system) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;
    const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

    backendSpecsActions.createEnvironmentStarted();

    try {
      const response = await axios.post(`${baseUrl}/environments`, { name, description });
      backendSpecsActions.createEnvironmentSuccess(response.data);
      await backendSpecsActions.fetchEnvironments();
      return { payload: response.data };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create environment';
      backendSpecsActions.createEnvironmentFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }
  };

export const deleteEnvironment =
  (envId) =>
  async (system) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;
    const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

    backendSpecsActions.deleteEnvironmentStarted();

    try {
      await axios.delete(`${baseUrl}/environments/${envId}`);
      backendSpecsActions.deleteEnvironmentSuccess(envId);

      // Clear active environment if it was the deleted one
      const activeEnv = backendSpecsSelectors.selectActiveEnvironment?.();
      if (activeEnv && activeEnv.id === envId) {
        backendSpecsActions.setActiveEnvironment(null);
      }

      await backendSpecsActions.fetchEnvironments();
      return { payload: envId };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to delete environment';
      backendSpecsActions.deleteEnvironmentFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }
  };

export const fetchEnvironmentDetail =
  (envId) =>
  async (system) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;
    const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

    backendSpecsActions.fetchEnvironmentDetailStarted();

    try {
      const response = await axios.get(`${baseUrl}/environments/${envId}`);
      backendSpecsActions.fetchEnvironmentDetailSuccess(response.data);
      return { payload: response.data };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch environment detail';
      backendSpecsActions.fetchEnvironmentDetailFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }
  };

export const upsertEnvSpecSetting =
  (envId, specId, proxyMode, upstreamEnvironment) =>
  async (system) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;
    const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

    backendSpecsActions.upsertEnvSpecSettingStarted();

    try {
      const response = await axios.put(`${baseUrl}/environments/${envId}/specs/${specId}`, {
        proxyMode: proxyMode || 'mock',
        upstreamEnvironment: upstreamEnvironment || '',
      });
      backendSpecsActions.upsertEnvSpecSettingSuccess(response.data);
      return { payload: response.data };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to update environment spec setting';
      backendSpecsActions.upsertEnvSpecSettingFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }
  };

export const upsertEnvEndpointSetting =
  (envId, specId, path, method, selectedExample, delayMs = null) =>
  async (system) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;
    const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

    backendSpecsActions.upsertEnvEndpointSettingStarted();

    try {
      const requestBody = {
        path,
        method: method.toUpperCase(),
        selectedExample,
      };

      if (delayMs !== null) {
        requestBody.delayMs = delayMs;
      }

      const response = await axios.put(
        `${baseUrl}/environments/${envId}/specs/${specId}/endpoints`,
        requestBody
      );
      backendSpecsActions.upsertEnvEndpointSettingSuccess(response.data);
      return { payload: response.data };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to save environment endpoint setting';
      backendSpecsActions.upsertEnvEndpointSettingFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }
  };

// Admin spec-access thunk actions (no Redux state — dialog uses local state)
export const fetchSpecAccess = (specId) => async (system) => {
  const { backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  const response = await axios.get(`${baseUrl}/admin/spec-access`, {
    params: { specId },
  });
  return response.data;
};

export const grantSpecAccess = (username, specId) => async (system) => {
  const { backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  const response = await axios.post(`${baseUrl}/admin/spec-access`, { username, specId });
  return response.data;
};

export const revokeSpecAccess = (username, specId) => async (system) => {
  const { backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  await axios.delete(`${baseUrl}/admin/spec-access`, {
    params: { username, specId },
  });
};

export const setUserDefaultSpec = (username, specId) => async (system) => {
  const { backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  await axios.put(`${baseUrl}/admin/spec-access/default`, null, {
    params: { username, specId },
  });
};

// Share link thunk actions (no Redux state — dialog uses local state)
export const fetchShareLinks = (specId) => async (system) => {
  const { backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  const response = await axios.get(`${baseUrl}/specs/${specId}/share-links`);
  return response.data;
};

export const createShareLink = (specId, label, expiresAt) => async (system) => {
  const { backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  const response = await axios.post(`${baseUrl}/specs/${specId}/share-links`, {
    label,
    expiresAt,
  });
  return response.data;
};

export const revokeShareLink = (linkId) => async (system) => {
  const { backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  await axios.delete(`${baseUrl}/specs/share-links/${linkId}`);
};

export const fetchSpecCors = (specId) => async (system) => {
  const { backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  const response = await axios.get(`${baseUrl}/specs/${specId}/cors`);
  return response.data;
};

export const updateSpecCors = (specId, allowedOrigins) => async (system) => {
  const { backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  const response = await axios.put(`${baseUrl}/specs/${specId}/cors`, { allowedOrigins });
  return response.data;
};

// Global config action creators
export const fetchGlobalConfigStarted = () => ({
  type: FETCH_GLOBAL_CONFIG_STARTED,
});

export const fetchGlobalConfigSuccess = (config) => ({
  type: FETCH_GLOBAL_CONFIG_SUCCESS,
  payload: config,
});

export const fetchGlobalConfigFailure = (error) => ({
  type: FETCH_GLOBAL_CONFIG_FAILURE,
  payload: error,
  error: true,
});

export const updateGlobalConfigStarted = () => ({
  type: UPDATE_GLOBAL_CONFIG_STARTED,
});

export const updateGlobalConfigSuccess = (config) => ({
  type: UPDATE_GLOBAL_CONFIG_SUCCESS,
  payload: config,
});

export const updateGlobalConfigFailure = (error) => ({
  type: UPDATE_GLOBAL_CONFIG_FAILURE,
  payload: error,
  error: true,
});

// Global config thunk actions
export const fetchGlobalConfig = () => async (system) => {
  const { backendSpecsActions, backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

  backendSpecsActions.fetchGlobalConfigStarted();

  try {
    const response = await axios.get(`${baseUrl}/config`);
    backendSpecsActions.fetchGlobalConfigSuccess(response.data);
    return { payload: response.data };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || 'Failed to fetch global config';
    backendSpecsActions.fetchGlobalConfigFailure(errorMessage);
    return { error: true, meta: { errorMessage } };
  }
};

export const updateGlobalConfig =
  (globalProxyEnabled, defaultUpstreamEnvironment) => async (system) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;
    const baseUrl = backendSpecsSelectors.selectBackendBaseUrl();

    backendSpecsActions.updateGlobalConfigStarted();

    try {
      const response = await axios.put(`${baseUrl}/config`, {
        globalProxyEnabled,
        defaultUpstreamEnvironment: defaultUpstreamEnvironment || '',
      });
      backendSpecsActions.updateGlobalConfigSuccess(response.data);
      return { payload: response.data };
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || 'Failed to update global config';
      backendSpecsActions.updateGlobalConfigFailure(errorMessage);
      return { error: true, meta: { errorMessage } };
    }
  };
